import { useState, useEffect } from "react";
import { TenantSettingsService } from "@/services/tenantSettingsService";

const CURRENCY_FALLBACK = { currency: "GBP", currencySign: "£" };

let cachedValue = null;
let cachedPromise = null;

const fetchDefaultCurrency = async () => {
  if (cachedValue) return cachedValue;
  if (cachedPromise) return cachedPromise;
  cachedPromise = TenantSettingsService.getDefaultCurrency()
    .then((result) => {
      cachedValue = result;
      return result;
    })
    .catch(() => CURRENCY_FALLBACK);
  return cachedPromise;
};

export const getDefaultCurrencyFallback = () => {
  if (cachedValue) return cachedValue;
  return CURRENCY_FALLBACK;
};

export const loadDefaultCurrency = fetchDefaultCurrency;

export const useDefaultCurrency = () => {
  const [defaultCurrency, setDefaultCurrency] = useState(
    () => cachedValue || CURRENCY_FALLBACK
  );
  const [loading, setLoading] = useState(!cachedValue);

  useEffect(() => {
    let mounted = true;
    fetchDefaultCurrency().then((result) => {
      if (mounted) {
        setDefaultCurrency(result);
        setLoading(false);
      }
    });
    return () => { mounted = false; };
  }, []);

  return { defaultCurrency, loading };
};
